import CART_ITEM from '../../../services/checkout/constants/cartItems';

/**
 * Retrieves the amount of packages selected for purchase for a given identity
 *
 * @param {Array} cart the current cart
 * @param {Object} identity the identity to get packages for
 * @returns {number|*}
 */
export const getPrintPackagesCountByIdentity = (cart, identity) => {
  if (!identity) {
    return 0;
  }

  return cart.reduce((sum, item) => {
    if (
      item.type === CART_ITEM.ALBUM_PRINT_PACKAGE &&
      item.identity?.id === identity.id
    ) {
      return sum + item.quantity;
    }

    return sum;
  }, 0);
};
